<template>

  <div class="hero">
    <div class="hero-text">
      <div class="">
        <h2>Learn with Hato</h2>
        <h3>Learn through play and take your pick of these creative workshops – curated by us.</h3>
      </div>
    </div>
    <div class="hero-wrapper" :class="[fill]">
      <div v-if="!isMobile()" class="iframe-wrapper">
        <iframe :src="video.source" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
      </div>
      <div v-if="isMobile()" class="background" :style="{'backgroundImage':'url(' + video.poster + ')'}"></div>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    size: {
      type: String,
      default: '50%'
    },
    fill: {
      type: String,
      default: 'contain'
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      video: {
        source: 'https://player.vimeo.com/video/222339794?api=1&background=1&mute=1&loop=1',
        poster: require('../assets/videos/hatopress-reel-viemo-poster-1.jpg')
      }
      // ,
      // isMobile: false
    }
  },
  methods: {
    handleWindowResize (event) {
      let self = this
      self.windowWidth = event.currentTarget.innerWidth
    },
    isMobile () {
      let self = this
      return self.windowWidth < 1024
    }
  },
  beforeDestroy: function () {
    let self = this
    window.removeEventListener('resize', self.handleWindowResize)
  },
  mounted () {
    let self = this
    window.addEventListener('resize', self.handleWindowResize)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {

}

.hero {
  position: relative;
  margin-bottom: 0rem;
  /* max-height: 70vh; */
  overflow: hidden;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.hero-text {
  position: absolute;
  /*bottom: 30px;
  left: 20px;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;

  font-size: 50px;
  font-size: 1.8rem;
  line-height: 1.2;
  font-weight: 500;
  /*letter-spacing: -1px;
  letter-spacing: 0;*/
  max-width: 22em;
  color: white;
  top: ;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  margin: auto;
}
.hero-wrapper {
  position: relative;
  margin: 0 0;
  max-width: 100%;
  padding-bottom: 50%;
  overflow: hidden;
  background: #000;

  padding-bottom: 0;
  width: 100%;
  height: 100%;
}
.hero-wrapper .iframe-wrapper {
  margin: 0;
  position: absolute;
  z-index: 2;
  pointer-events: none;
  opacity: 0.8;

  position: relative;
  width: 100%;
  height: 100%;
}
.hero-wrapper .background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.6;
  background-size: cover;
  background-position: bottom center;
}
.hero-wrapper.cover .iframe-wrapper {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* height: auto; */
}
.hero-wrapper.cover .iframe-wrapper iframe {
  height: 100%;
  max-width: 120%;
  width: 116%;

  height: 100%;
  max-width: 110%;
  width: 110%;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

h2 {
  font-size: 2.5rem;
  font-weight: 500;
  margin: .5rem auto;
}
h3 {
  font-size: 1.5rem;
  line-height: 1.5;
  font-weight: 500;
  margin: .5rem auto;
}

video {
  display: block;
  width: 100%;
}

@media screen and (max-width: 1024px) {

}
@media screen and (max-width: 768px) {
  /* .hero-text {
    font-size: 40px;
  }
  .hero-wrapper {
    padding-bottom: 50%;
  } */
}
@media screen and (max-width: 640px) {
  /* .hero-text {
    font-size: ;
  } */
  h2 {
    font-size: 1.75rem;
    margin: .5rem auto;
  }
  h3 {
    font-size: 1.25rem;
    padding: 0 .5rem;
    margin: .5rem auto;
  }
  /* .hero-wrapper {
    padding-bottom: 75%;
  } */
}
</style>



// WEBPACK FOOTER //
// HeroVideo.vue?3339f872